import { Users, CheckCircle, Clock, AlertTriangle } from 'lucide-react';
import type { EquipeStats } from '@/hooks/queries/useMembresQuery';

interface EquipeKPICardsProps {
  stats: EquipeStats;
}

/**
 * 4 cartes métriques de la page Mon équipe
 * Reprend le pattern exact de NewKPICards (Bricolage Grotesque, mêmes paddings)
 */
export const EquipeKPICards = ({ stats }: EquipeKPICardsProps) => {
  const percentage = stats.total > 0
    ? Math.round((stats.conformes / stats.total) * 100)
    : 0;

  const cards = [
    {
      label: 'Total équipe',
      value: stats.total,
      icon: Users,
      iconClassName:
        'border border-[hsl(var(--app-border-subtle))] bg-[hsl(var(--app-surface-muted))] text-[hsl(var(--app-text))]',
    },
    {
      label: 'Conformes',
      value: stats.conformes,
      icon: CheckCircle,
      iconClassName:
        'border border-emerald-200/80 bg-emerald-50/80 text-emerald-600',
    },
    {
      label: 'En attente',
      value: stats.en_attente + stats.verification_en_cours,
      icon: Clock,
      iconClassName:
        'border border-[hsl(var(--app-border-subtle))] bg-[hsl(var(--app-surface-muted))] text-[hsl(var(--app-text-muted))]',
    },
    {
      label: 'À régulariser',
      value: stats.a_regulariser,
      icon: AlertTriangle,
      iconClassName:
        'border border-rose-200/80 bg-rose-50/80 text-rose-600',
    },
  ] as const;

  return (
    <div className="grid grid-cols-1 gap-3 md:grid-cols-2 xl:grid-cols-4">
      {cards.map((card) => {
        const Icon = card.icon;

        return (
          <div key={card.label} className="app-surface rounded-[18px] p-4">
            <div className="flex items-start justify-between gap-4">
              <div>
                <p className="text-[11px] font-semibold uppercase tracking-[0.14em] text-[hsl(var(--app-text-muted))]">
                  {card.label}
                </p>
            <div className="mt-2 text-[24px] font-semibold leading-none tracking-[-0.03em] text-[hsl(var(--app-text-strong))]">
                  {card.value}
                </div>
              </div>
              <div className={`rounded-2xl p-2 ${card.iconClassName}`}>
                <Icon className="h-[17px] w-[17px]" />
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
};
